<template>
    <v-container class="app-page-container">
        <v-card v-if="groups" class="shadow-none app-page-card">
            <v-card-title>
                Groups:
            </v-card-title>
            <v-card-text>
                <v-layout word wrap>
                    <v-flex xs12>
                        <p>Click to select/deselect group: </p>
                        <v-chip v-for="(item,index) in groups" 
                                :key="index" style="margin:2px"
                                :color="getChipColor(item)" 
                                @click="changeGroupStatus(item)">
                            {{item.group_name}}
                        </v-chip>
                    </v-flex>
                    <v-flex xs1></v-flex>
                </v-layout>
            </v-card-text>
                   
            <v-card-title>
                <v-tabs center-active  color="blue" slider-color="blue" class="customTabTitle" >
                   <v-tab @click="typeRes = 0">Course</v-tab>
                   <v-tab @click="typeRes = 1">Exercises</v-tab>
                   <v-tab @click="typeRes = 2">Competitions</v-tab>
                   <v-tab @click="typeRes = 3">Duels</v-tab>
                </v-tabs>
            </v-card-title>
           <v-card-text v-if="prepared">
               <CourseResults v-if="typeRes == 0" v-bind:groups_ids="groups_ids" v-bind:course_id="course_id" />
               <CompetitionResults v-if="typeRes == 2" v-bind:groups_ids="groups_ids" v-bind:course_id="course_id" />
           </v-card-text>
        </v-card>
    </v-container>
</template>

<script>
 import axios from '../../axios-auth.js'
 import CourseResults from './../../components/dashboard/course_results.vue'
 import CompetitionResults from './../competitions/competition_results.vue'

export default {
    data() {
        return {
            course_id: 0,
            groups_ids :null,
            groups:null,
            prepared: false,
            typeRes: 0
        }
    },
    components: {
        CourseResults,
        CompetitionResults
    },
    mounted() {
        this.initData()
    },
    methods : {
        initData() {
            this.$store.commit('setBreadCrumbs',[{text: 'Teacher dashboard', href: '/teacher_dashboard'},
                                                 {text: 'Students', href: '/teacher_students/'+this.$route.params.course_id+'/'+this.$route.params.group_id}
            ])

            this.course_id = this.$route.params.course_id
            this.group_id = this.$route.params.group_id
            let _data = {
                course_id: this.$route.params.course_id
            }
            axios.post('/get-teaching-groups-course', _data, this.$store.getters.getAxiosConfig )
                .then(res => {                    
                    this.groups_ids = []
                    this.groups = []
                    var settt = 0
                    for(let i=0; i<res.data.groups.length; i++) {
                        if (this.group_id == 0) settt = 1
                        else if (this.group_id == res.data.groups[i].id) settt = 1
                             else settt = 0  
                        if (settt) this.groups_ids.push(res.data.groups[i].id)
                        this.groups.push( {id : res.data.groups[i].id, group_name: res.data.groups[i].group_name, show: settt})
                    }
                    this.prepared = true
                })
                .catch(error => {
                    this.$store.commit('setFeedback', error)
                }) 
        },
        getChipColor(item) {
            if (item.show == 1) return "orange"
            return "silver"
        },
        changeGroupStatus(item) {
            if (item.show == 1)
                this.groups_ids.splice(this.groups_ids.indexOf(item.id),1)
            else
                this.groups_ids.push(item.id)
            item.show = Math.abs(1-item.show)
            // this.refreshData()
        }
    }
}
</script>
